// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSFinance = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/finance_01.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_02.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_03.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_04.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_05.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_06.jpg",
			"video": false
		},
		{
			"link": "/img/apps/finance_07.jpg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">TLS Finance</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tls.tlsfinance"}
				apple_store={"https://apps.apple.com/br/app/tls-finance/id6760033486"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Tenha o controle total da sua vida financeira com o <strong>TLS Finance</strong>!<br />
										Desenvolvido para simplificar sua organização financeira, o aplicativo ajuda você a gerenciar contas, despesas, empréstimos e investimentos de forma prática, visual e inteligente.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Controle de Contas:</strong> Cadastre múltiplas contas, como corrente, poupança, cartão e dinheiro, acompanhando seus saldos de forma organizada.</li>
											<li><strong>Despesas Pontuais e Recorrentes:</strong> Registre gastos únicos ou programe despesas recorrentes, como aluguel, assinaturas e mensalidades.</li>
											<li><strong>Gestão de Empréstimos:</strong> Controle valores emprestados e recebidos, acompanhe parcelas e mantenha suas finanças sempre atualizadas.</li>
											<li><strong>Acompanhamento de Investimentos:</strong> Monitore seus investimentos e visualize a evolução do seu patrimônio.</li>
											<li><strong>Calendário Financeiro:</strong> Visualize compromissos financeiros organizados por dia, com clareza sobre entradas e saídas.</li>
											<li><strong>Relatórios Inteligentes:</strong> Analise gráficos e relatórios detalhados para compreender seus hábitos financeiros e tomar melhores decisões.</li>
										</ul>
										<br />
										Com o TLS Finance, você organiza sua vida financeira em um único lugar, ganhando mais controle, planejamento e tranquilidade para alcançar seus objetivos.
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										Toma el control total de tu vida financiera con <strong>TLS Finance</strong>.<br />
										Desarrollada para simplificar tu organización financiera, la aplicación te ayuda a gestionar cuentas, gastos, préstamos e inversiones de forma práctica, visual e inteligente.
										<br />
										<br />
										<h3>Funciones:</h3><br />
										<ul>
											<li><strong>Control de Cuentas:</strong> Registra múltiples cuentas, como cuenta corriente, ahorro, tarjeta y efectivo, y supervisa tus saldos fácilmente.</li>
											<li><strong>Gastos Únicos y Recurrentes:</strong> Registra gastos puntuales o programa pagos recurrentes como alquileres, suscripciones y cuotas.</li>
											<li><strong>Gestión de Préstamos:</strong> Controla montos prestados y recibidos, realiza seguimiento de cuotas y mantén tus finanzas organizadas.</li>
											<li><strong>Seguimiento de Inversiones:</strong> Monitorea tus inversiones y visualiza el crecimiento de tu patrimonio.</li>
											<li><strong>Calendario Financiero:</strong> Consulta tus compromisos financieros organizados por día para tener una visión clara de ingresos y gastos.</li>
											<li><strong>Informes Inteligentes:</strong> Analiza gráficos e informes detallados para comprender mejor tus hábitos financieros y tomar decisiones estratégicas.</li>
										</ul>
										<br />
										Con TLS Finance, tendrás todas tus finanzas organizadas en un solo lugar para lograr un mayor control, planificación y tranquilidad.
									</div>
								)
								:
								(
									<div className='term_just'>
										Take full control of your finances with <strong>TLS Finance</strong>!<br />
										Designed to simplify your financial organization, the app helps you manage accounts, expenses, loans, and investments in a practical, visual, and intelligent way.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Account Management:</strong> Register multiple accounts, including checking, savings, credit cards, and cash, while keeping track of balances.</li>
											<li><strong>One-Time and Recurring Expenses:</strong> Record single expenses or schedule recurring payments such as rent, subscriptions, and memberships.</li>
											<li><strong>Loan Tracking:</strong> Manage borrowed and lent amounts, monitor installments, and keep your finances organized.</li>
											<li><strong>Investment Monitoring:</strong> Track your investments and visualize your wealth growth over time.</li>
											<li><strong>Financial Calendar:</strong> View your financial commitments organized by day, giving you a clear picture of income and expenses.</li>
											<li><strong>Smart Reports:</strong> Analyze detailed charts and reports to better understand your financial habits and make informed decisions.</li>
										</ul>
										<br />
										With TLS Finance, all your financial information is organized in one place, helping you gain more control, planning, and confidence in your financial future.
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSFinance